import { useDispatch, useSelector, shallowEqual } from 'react-redux';
import { useMaskPII } from 'hooks/useMaskPII';

import { NsContent } from 'components/common/ns-content/NsContent';
import NsStandout from '@britishgasenergy/react-nucleus/dist/nuc-components/NsStandout';
import { NsRadioInput } from 'components/common/ns-radio-input/NsRadioInput';

import { selectedAddress } from 'state/selected-address/selected-address-slice';
import {
  selectDetails as selectAccountDetails,
  setAccountField
} from 'state/account/account-slice';
import { stringToBool } from 'utils/misc';
import { NsFormGroup } from '@britishgasenergy/react-nucleus';

export const testId = 'changeOfTenancyTestId';

export const ChangeOfTenancy = () => {
  const { mask } = useMaskPII();
  const dispatch = useDispatch();

  const { isChangeOfTenancy, isChangeOfName } = useSelector(
    selectAccountDetails,
    shallowEqual
  );
  const address = useSelector(selectedAddress, shallowEqual) || {};

  const handleChangeOfName = (event) => {
    const {
      target: { value, name }
    } = event;
    dispatch(setAccountField({ name, value: stringToBool(value) }));
    if (value === 'false') {
      dispatch(setAccountField({ name: 'isChangeOfTenancy', value: false }));
    }
  };

  const handleRadioChange = (event) => {
    const {
      target: { value, name }
    } = event;
    dispatch(setAccountField({ name, value: stringToBool(value) }));
  };

  return (
    <NsContent spacing="loose" data-testid={testId}>
      <NsStandout>
        <h5>Your address</h5>
        <p {...mask}>
          {address?.displayName}, <span {...mask}>{address?.postcode}</span>
        </p>
      </NsStandout>
      <NsFormGroup legend="Is your name on the energy bills for this address?">
        <NsRadioInput
          className="inline"
          name="isChangeOfName"
          dataTestId="radioChangeNameTestId"
          onChange={handleChangeOfName}
          value={`${isChangeOfName}`}
          options={[
            {
              label: 'Yes',
              value: 'false'
            },
            {
              label: 'No',
              value: 'true'
            }
          ]}
        />
        {isChangeOfName && (
          <NsRadioInput
            name="isChangeOfTenancy"
            dataTestId="radioChangeTenancyTestId"
            heading="Please let us know why so we can inform your current supplier"
            onChange={handleRadioChange}
            value={`${isChangeOfTenancy}`}
            options={[
              {
                label: 'I’m moving in or have moved in recently',
                value: 'true'
              },
              {
                label: 'I want to change the account holder name',
                value: 'false'
              }
            ]}
          />
        )}
      </NsFormGroup>
    </NsContent>
  );
};

export default ChangeOfTenancy;
